(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/create-game/assets/javascripts/services/fetch-account-balance.js') >= 0) return;  svs.modules.push('/components/marketplace-data/create-game/assets/javascripts/services/fetch-account-balance.js');
"use strict";


const {
  ApiProxy
} = svs.components.lbUtils.apiProxy;
setGlobal('svs.components.marketplaceData.createGame.services.fetchAccountBalance', callback => {
  const proxy = ApiProxy.create();
  proxy.fetch('/player/1/info', {
    method: 'GET'
  }).then(_ref => {
    let {
      accountBalance
    } = _ref;
    const balance = Number(accountBalance.replace(',', '.'));
    callback(null, balance);
  }).catch(error => {
    callback(error.responseJSON ? error.responseJSON.error : error);
  });
});

 })(window);